<div class="content-header">
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-12">
                <ol class="breadcrumb float-sm-left">
                    <li class="breadcrumb-item">
                        <a [routerLink]="['/']">
                            <i class="fas fa-home"></i>
                            Página Inicial</a>
                    </li>
                    <li class="breadcrumb-item active">Plano de Ação</li>
                </ol>
            </div>
        </div>
    </div>
</div>

<div class="content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card card-outline card-lightblue">
                    <div class="card-header">
                        <h3 class="card-title mb-0">
                            <i class="fas fa-table pr-2"></i>
                            Plano de Ação
                        </h3>
                    </div>
                    <div class="card-body p-2">
                        <app-plano-acao-list>
                            <app-plano-acao-filtro showButtonFilter="false"></app-plano-acao-filtro>
                        </app-plano-acao-list>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>